module.exports = __webpack_public_path__ + "static/img/1.6c2b3fe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/7/1/eng/1.png
// module id = Z4Ie
// module chunks = 0